// extracted by mini-css-extract-plugin
export default {"page_wrapper":"styles_page_wrapper__J8UKJ","app_name":"styles_app_name__sdNcv"};